<template>
  <el-dialog
    title="修改失效时间"
    :visible.sync="dialogInfo.show"
    width="600px"
    :before-close="closeFrom"
    :close-on-click-modal="false"
  >
    <el-form
      :model="dateForm"
      ref="dateForm"
      label-width="100px"
      :rules="rules"
      class="dateForm"
    >
       <el-form-item label="失效时间：" prop="timeType" required>
          <el-radio-group v-model="dateForm.timeType">
            <el-radio :label="1">永久有效</el-radio>
            <el-radio :label="2">设置失效时间</el-radio>
          </el-radio-group>
        </el-form-item>
      <el-form-item prop="time" v-if="dateForm.timeType == 2">
        <el-date-picker
          v-model="dateForm.time"
          type="date"
          placeholder="选择失效时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <div class="mt-10">(选中日期次日00:00 CDN加速失效)</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" title="取消"></butn>
      <butn btntype="primary" @click.native="submit()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { cdnRecordUpdate } from "../../api/resourceService";

export default {
  components: { butn },
  props: ["dialogInfo"],
  data() {
    return {
      dateForm: {
        timeType: 1,
        time: "",
      },
      rules: {
        time: [
          {
            required: true,
            message: "请选择失效时间",
            trigger: "change",
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 24 * 60*60*1000;
        },
      },
    };
  },
  methods: {
    submit() {
      this.$refs["dateForm"].validate((valid) => {
        if (valid) {
          let dateTime = this.dateForm.time;
          if (this.dateForm.timeType === 1) {
            dateTime = ''
          }
          cdnRecordUpdate({
            uuids: this.dialogInfo.uuids,
            dateTime: dateTime,
          }).then(({code, data}) => {
            if (code === 0) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.closeFrom(true);
            }
          })
        }
      });
    },
    closeFrom(flag = false) {
      this.$emit("close", flag);
    },
  },
  created() {
    this.dateForm.timeType = this.dialogInfo.timeType;
    this.dateForm.time = this.dialogInfo.defaultTime || ""

  },
};
</script>

<style lang="scss" scoped>
.c-dia {
  max-height: 390px;
  overflow: auto;
  border: 1px solid #dcdcdc;
  .head {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
  }
}
.mt-10 {
  margin-top: 10px;
}

</style>
